import { computed, Injectable, signal } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

export type Language = 'pt' | 'en';

@Injectable({
  providedIn: 'root',
})
export class LanguageStore {
  private readonly STORAGE_KEY = 'dreampay_language';

  private readonly _language = signal<Language>('pt');

  readonly language = this._language.asReadonly();
  readonly isPortuguese = computed(() => this._language() === 'pt');
  readonly isEnglish = computed(() => this._language() === 'en');

  constructor() {
    this.loadLanguage();
  }

  async setLanguage(lang: Language): Promise<void> {
    this._language.set(lang);
    await Preferences.set({ key: this.STORAGE_KEY, value: lang });
  }

  async toggleLanguage(): Promise<void> {
    const newLang = this._language() === 'pt' ? 'en' : 'pt';
    await this.setLanguage(newLang);
  }

  private async loadLanguage(): Promise<void> {
    const { value } = await Preferences.get({ key: this.STORAGE_KEY });
    if (value === 'pt' || value === 'en') {
      this._language.set(value);
    }
  }
}
